<template>
  <div id="contenedor-main">
    <main-menu class="d-print-none"></main-menu>
    <main-app-bar class="d-print-none"></main-app-bar>
    <v-main class="main-contenido">
      <router-view/>
    </v-main>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue';
import MainAppBar from '@/components/MainAppBar.vue';

export default {
  name: 'AdministracionMain',
  components: {
    MainMenu,
    MainAppBar,
  },
  data() {
    return {};
  },
  mounted() {
    // this.mixChecarAutentificacion();
  },
};
</script>

<style lang="scss" scoped>
.main-contenido {
  background-color: #F2F6FF;
}

@media print {
  .main-contenido {
    background-color: #fff !important;
  }
}
</style>
